import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { SupplierTaxIDField } from './components/SupplierTaxIDField';
import { SupplierPhoneNumberField } from './components/SupplierPhoneNumberField';
import { SupplierNameField } from './components/SupplierNameField';
import { IsOpenPriceCheckbox } from './components/IsOpenPriceCheckbox';
import { OpenPriceField } from './components/OpenPriceField';
import style from './Supplier.module.scss';

export const Supplier: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<>
			<div className={style.heading}></div>
			<div className={style.row}>
				<SupplierTaxIDField />
				<SupplierPhoneNumberField />
			</div>
			<div className={style.row}>
				<SupplierNameField />
				<IsOpenPriceCheckbox />
			</div>
			{restaurantForFullInfo?.isOpenPriceServiceCharge && (
				<div className={style.row}>
					<div className={style.flex1} />
					<OpenPriceField />
				</div>
			)}
		</>
	);
};
